var _rect, _path, _rect2, _path2, _rect3, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRecommendations = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 81,
    viewBox: "0 0 200 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.636719,
    width: 144,
    height: 20,
    rx: 10,
    fill: "#7871C9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 14.1116L8.02501 10.6366L6.84167 11.8116L11.5 16.4699L21.5 6.46992L20.325 5.29492L11.5 14.1116Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 30.6367,
    width: 200,
    height: 20,
    rx: 10,
    fill: "#DF8981"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 44.1116L8.02501 40.6366L6.84167 41.8116L11.5 46.4699L21.5 36.4699L20.325 35.2949L11.5 44.1116Z",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 60.6367,
    width: 164,
    height: 20,
    rx: 10,
    fill: "#1B2473"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 74.1116L8.02501 70.6366L6.84167 71.8116L11.5 76.4699L21.5 66.4699L20.325 65.2949L11.5 74.1116Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRecommendations);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/recommendations.c50716e2348a95c8e6e4de6c8351c786.svg";